/**
 * Explicit allow-list of step component keys handled by KUIUnifiedOnboardingShell.
 */
export type OnboardingStepComponentKey = 'email' | 'otp' | 'aboutYou' | 'tooYoung' | 'marketing' | 'terms' | 'passwordSetup';

export type AboutYouField = 'firstName' | 'lastName' | 'birthMonthYear' | 'stateId';
export const ALL_ABOUT_YOU_FIELDS: readonly AboutYouField[] = ['firstName', 'lastName', 'birthMonthYear', 'stateId'];

export interface AboutYouPayload {
  firstName: string;
  lastName: string;
  /** YYYY-MM */
  birthMonthYear: string;
  stateId: string;
}

/** A returning student answers only the fields they were missing. */
export type AboutYouAnswers = Partial<AboutYouPayload>;

export interface OnboardingState {
  email: string;
  otpCode: string;
  agreedToTerms: boolean;
  /** Set after OTP verification; drives steps that only apply to new accounts. */
  isNewUserRole: boolean;
  /** Prefilled from the social provider on an SSO return; forwarded to signup. */
  firstName?: string;
  lastName?: string;
  /** YYYY-MM, from the about-you step; forwarded to signup. */
  birthMonthYear?: string;
  stateId?: string;
  /** Set by the about-you step from the server's age check; drives the marketing box. */
  canBeMarketed: boolean;
  /** Set when the server refused the account floor; routes to the stop screen. */
  tooYoung: boolean;
  /** Set when sign-up handed back a first-password token; routes to the password step. */
  canSetPassword?: boolean;
  /** Sign-in questions: which about-you fields the server says are missing. */
  aboutYouFields?: AboutYouField[];
  /** Sign-in questions: whether the marketing box is shown after about-you. */
  showMarketingBox?: boolean;
}

export interface OnboardingStepConfig {
  id: string;
  blinkyMessage: string;
  /** Omit for a message-only, tap-to-advance step. */
  component?: OnboardingStepComponentKey;
  /** Skip this step on advance when the predicate returns true. */
  skipIf?: (state: OnboardingState) => boolean;
  /** Side effects after the step finishes (analytics, redirect, etc.). */
  onComplete?: (state: OnboardingState) => void | Promise<void>;
}
